import { LegalLayout, Section, FileText } from "./LegalPage";

export default function TermsOfService() {
  return (
    <LegalLayout icon={FileText} kicker="VITTYYO" title="Terms of Service" updated="July 19, 2026">
      <p data-testid="terms-intro">
        These Terms of Service ("Terms") govern your use of Vittyyo ("Vittyyo," "we," "us"). By creating an account
        or using the service, you agree to these Terms. If you do not agree, do not use the service.
      </p>

      <Section heading="1. What Vittyyo is">
        <p>Vittyyo is an AI-powered tool that generates personalized, step-by-step how-to manuals, along with
          AI-generated illustrations, optional voice-overs, and optional videos. Content is generated by artificial
          intelligence and may contain mistakes or inaccuracies. It is provided for general, informational purposes and
          is not professional advice. Always use your own judgment and take appropriate safety precautions, and consult a
          qualified professional for important, hazardous, or regulated tasks.</p>
      </Section>

      <Section heading="2. Eligibility and your account">
        <p>You must be old enough to form a binding contract in your jurisdiction to use the service. You are responsible
          for keeping your login credentials secure and for all activity under your account. Provide accurate information
          when registering.</p>
      </Section>

      <Section heading="3. Credits and payments">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Generating content requires credits, which are purchased in packs. Payments are processed by Stripe.</li>
          <li>Except where required by law, purchases are non-refundable. Prices may change over time.</li>
        </ul>
      </Section>

      <Section heading="4. Acceptable use">
        <p>You agree not to use Vittyyo to create, upload, or share content that is unlawful, harmful, hateful,
          harassing, sexually explicit, deceptive, or that infringes others' rights. You will keep content
          family-friendly. We use automated moderation and may refuse, remove, or restrict content and may suspend or
          terminate accounts that violate these Terms.</p>
      </Section>

      <Section heading="5. Your content and ownership">
        <p>You retain ownership of the goals you provide and, as between you and us, the content generated for you,
          subject to the rights of the AI providers and applicable law. By sharing content to the public Community board,
          you grant Vittyyo and its users a non-exclusive license to display and let others view and download that
          content. You are responsible for the content you create and where you share it.</p>
      </Section>

      <Section heading="6. Release of liability on download">
        <p>Once you download, export, or save any content you create with Vittyyo — including videos, images, and
          written documents — you release Vittyyo from any and all liability relating to that content. We are not
          responsible for how you use it or where you upload, publish, or share it. By downloading any content you create
          with our service, you acknowledge and agree to all of these Terms.</p>
      </Section>

      <Section heading="7. Third-party services and links">
        <p>The service integrates third parties (including OpenAI, Google, Stripe, and Amazon). We are an Amazon Associate
          and may earn from qualifying purchases made through supply links. Third-party services are governed by their own
          terms and policies, which we do not control. Product suggestions are informational only; do your own research
          before purchasing.</p>
      </Section>

      <Section heading="8. Disclaimers and limitation of liability">
        <p>The service and all generated content are provided <span className="font-semibold">"as is"</span> and
          <span className="font-semibold"> "as available,"</span> without warranties of any kind, express or implied,
          including fitness for a particular purpose. To the fullest extent permitted by law, Vittyyo disclaims all
          liability for uploaded content, generated results, reliance on any instructions, and content shared to other
          platforms, and shall not be liable for any indirect, incidental, or consequential damages.</p>
      </Section>

      <Section heading="9. Termination">
        <p>You may stop using the service at any time. We may suspend or terminate your access if you violate these Terms
          or to protect the service and its users.</p>
      </Section>

      <Section heading="10. Changes to these Terms">
        <p>We may update these Terms from time to time. When we do, we will revise the "Last updated" date above. Your
          continued use of the service after changes take effect constitutes acceptance of the updated Terms.</p>
      </Section>

      <Section heading="11. Contact us">
        <p>Questions about these Terms? Contact us at <span className="font-semibold">support@stepmystep.com</span>.</p>
      </Section>
    </LegalLayout>
  );
}
